import React from "react";

export default function ReturnPolicy() {
  return (
    <div
      className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      data-aos="fade-up"
    >
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 px-8 py-12 text-white">
          <h1 className="text-4xl font-bold mb-3">
            Cancellation & Refund Policy
          </h1>

          <p className="text-lg text-orange-100 max-w-2xl">
            Please review our cancellation and refund terms
            carefully before booking any consultation or
            service with us.
          </p>
        </div>

        {/* Content */}
        <div className="p-8 md:p-12 space-y-10 text-gray-700">

          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="leading-7 text-gray-600">
              At <strong>HOLLY ZOLLY</strong>, we are committed
              to providing authentic and personalized Vastu
              consultation services. Due to the nature of
              our services, our cancellation and refund
              policy is designed to be fair and transparent
              for both clients and consultants.
            </p>
          </section>

          {/* Service Eligibility */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Service Eligibility
            </h2>

            <ul className="list-disc pl-6 space-y-3 text-gray-600">
              <li>
                All services are consultation-based
                (online or offline).
              </li>
              <li>
                Once a consultation or report is delivered,
                the service is considered fulfilled.
              </li>
              <li>
                Personalized consultations are tailored
                to individual requirements.
              </li>
            </ul>
          </section>

          {/* Cancellation Policy */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Cancellation Policy
            </h2>

            <ul className="list-disc pl-6 space-y-3 text-gray-600">
              <li>
                Appointments can be cancelled or
                rescheduled at least{" "}
                <span className="font-semibold">
                  24 hours
                </span>{" "}
                before the scheduled consultation.
              </li>

              <li>
                Cancellations made within 24 hours
                of the scheduled appointment may
                not be eligible for a refund.
              </li>

              <li>
                Cancellation approval is subject
                to review based on service status.
              </li>
            </ul>
          </section>

          {/* Refund Policy */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Refund Policy
            </h2>

            <div className="bg-orange-50 border border-orange-200 rounded-xl p-5">
              <ul className="list-disc pl-6 space-y-3 text-gray-700">
                <li>
                  Refunds are applicable only if
                  the service has not been initiated.
                </li>

                <li>
                  Once consultation or report
                  preparation has started, refunds
                  will not be provided.
                </li>

                <li>
                  Approved refunds are processed
                  within{" "}
                  <span className="font-semibold text-orange-700">
                    5–7 business days
                  </span>.
                </li>
              </ul>
            </div>
          </section>

          {/* Non Refundable Services */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Non-Refundable Services
            </h2>
            <p className="leading-7 text-gray-600">
              Personalized Vastu reports, site visits,
              customized recommendations, and services
              that have already been delivered are
              non-refundable, as they are specially
              tailored to each client's requirements.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Contact Us
            </h2>

            <p className="text-gray-600 leading-7">
              For any questions regarding cancellations
              or refunds, please contact our support team.
            </p>

            <div className="mt-4 p-5 bg-gray-100 rounded-xl">
              <p>
                <span className="font-semibold">
                  Email:
                </span>{" "}
                vastukkalp2007gmail.com
              </p>

              <p>
                <span className="font-semibold">
                  Phone:
                </span>{" "}
                +91 99095 11961
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}